export const crmOptions = [
    'Hubspot',
    'High Level',
    'Monday.com',
    'Salesforce',
    'Pylon'
]

export const paletteOptions = {
    'Navy Blue': '#003366',
    'Deep Blue': '#0077b6',
    'Forest Green': '#228B22',
    'Grass Green': '#41980A',
    'Crimson Red': '#DC143C',
    'Burnt Orange': '#FF6D00',
    'Golden Yellow': '#FFD700',
    'Aqua Teal': '#62A8AC',
    'Charcoal Grey': '#36454F'
}

export const monthOptions = [
    {value: 'January', label: 'January'},
    {value: 'February', label: 'February'},
    {value: 'March', label: 'March'},
    {value: 'April', label: 'April'},
    {value: 'May', label: 'May'},
    {value: 'June', label: 'June'},
    {value: 'July', label: 'July'},
    {value: 'August', label: 'August'},
    {value: 'September', label: 'September'},
    {value: 'October', label: 'October'},
    {value: 'November', label: 'November'},
    {value: 'December', label: 'December'},
]

export const countyOptions = [
    // {value: 'All', label: 'All'},
    //{value: 'Antrim', label: 'Antrim'},
    //{value: 'Armagh', label: 'Armagh'},
    {value: 'Carlow', label: 'Carlow'},
    {value: 'Cavan', label: 'Cavan'},
    {value: 'Clare', label: 'Clare'},
    {value: 'Cork', label: 'Cork'},
    //{value: 'Derry', label: 'Derry'},
    {value: 'Donegal', label: 'Donegal'},
    //{value: 'Down', label: 'Down'},
    {value: 'Dublin', label: 'Dublin'},
    //{value: 'Fermanagh', label: 'Fermanagh'},
    {value: 'Galway', label: 'Galway'},
    {value: 'Kerry', label: 'Kerry'},
    {value: 'Kildare', label: 'Kildare'},
    {value: 'Kilkenny', label: 'Kilkenny'},
    {value: 'Laois', label: 'Laois'},
    {value: 'Leitrim', label: 'Leitrim'},
    {value: 'Limerick', label: 'Limerick'},
    {value: 'Longford', label: 'Longford'},
    {value: 'Louth', label: 'Louth'},
    {value: 'Mayo', label: 'Mayo'},
    {value: 'Meath', label: 'Meath'},
    {value: 'Monaghan', label: 'Monaghan'},
    {value: 'Offaly', label: 'Offaly'},
    {value: 'Roscommon', label: 'Roscommon'},
    {value: 'Sligo', label: 'Sligo'},
    {value: 'Tipperary', label: 'Tipperary'},
    //{value: 'Tyrone', label: 'Tyrone'},
    {value: 'Waterford', label: 'Waterford'},
    {value: 'Westmeath', label: 'Westmeath'},
    {value: 'Wexford', label: 'Wexford'},
    {value: 'Wicklow', label: 'Wicklow'}
]

export const countryOptions = [
    {value: 'Ireland', label: 'Ireland'}
]

export const validEmail = new RegExp('^[a-zA-Z0-9._:$!%-]+@[a-zA-Z0-9.-]+.[a-zA-Z]$') // standard email format
export const validPhone = new RegExp('^[0-9+]{9,15}$') // string between 9 and 15 characters long with numbers or + symbol
export const validDob = new RegExp('^(0?[1-9]|1[012])[- /.](0?[1-9]|[12][0-9]|3[01])[- /.](19|20)?[0-9]{2}$') // Date (MM/DD/YYYY)/(MM-DD-YYYY)/(MM.DD.YYYY)/(MM DD YYYY)

export const productCategories = [
    'SolarPanel', 
    'SolarInverter', 
    'SolarBattery', 
    'MonitoringSystem', 
    'PowerDiverter', 
    'EVCharger',
    'BlackoutProtection',
    'SmartDevice',
    'Optimiser',
    'HeatPump',
    'WaterCylinder',
    'Insulation'
];

export const productCategoryLabels = {
    SolarPanel: "Solar Panels",
    SolarInverter: "Solar Inverter",
    EVCharger: "EV Charger",
    MonitoringSystem: "Monitoring System",
    SolarBattery: "Solar Battery",
    PowerDiverter: "Power Diverter",
    BlackoutProtection: "Blackout Protection",
    SmartDevice: "Smart Device",
    Optimiser: "Optimiser",
    HeatPump: "Heat Pump",
    WaterCylinder: "Water Cylinder",
    Insulation: "Insulation"
};


export const productTypes = [
    'Solar',
    'Insulation',
    'EV Charger',
    'Boiler',
    'Heat Pump'
];

// Maps a product type (as stored in company.productsAvailable) to the
// technology/brand categories relevant to that product. Used to render the
// correct technology selectors per product on a provider's profile.
export const productCategoryMap = {
    'Solar': [
        'SolarPanel',
        'SolarInverter',
        'SolarBattery',
        'MonitoringSystem',
        'PowerDiverter',
        'Optimiser',
        'BlackoutProtection',
        'SmartDevice'
    ],
    'EV Charger': [
        'EVCharger'
    ],
    'Heat Pump': [
        'HeatPump',
        'WaterCylinder'
    ],
    'Insulation': [
        'Insulation'
    ]
};

export const panelWarrantyOptions = Array.from({ length: 30 }, (_, i) => {
  const year = i + 1;
  const label = `${year} year${year === 1 ? '' : 's'}`;
  return { value: label, label };
});

// Warranty options ranging from 0 to 30 years, used for warranty fields that
// allow "0 years" (e.g. Performance/Heat Pump/Insulation warranties).
export const warrantyYearOptions0to30 = Array.from({ length: 31 }, (_, i) => {
  const year = i;
  const label = `${year} year${year === 1 ? '' : 's'}`;
  return { value: label, label };
});

// Heat pump source types offered to providers.
export const heatPumpSourceOptions = [
  { value: 'Air source', label: 'Air source' },
  { value: 'Ground source', label: 'Ground source' },
  { value: 'Water source', label: 'Water source' }
];

// Non-brand fields rendered for each technology category entry. Every category
// also has a Brand selector and a product image; these describe the extra
// fields. Used to render multiple entries per category consistently across the
// solar TechnologyCard and the per-product ProductCard.
export const technologyCategoryFields = {
    SolarPanel: [
        { key: 'wattage', label: 'Wattage (W)', type: 'number', placeholder: '440' },
        { key: 'warranty', label: 'Warranty (Years)', type: 'warranty' },
        { key: 'description', label: 'Description', type: 'text', placeholder: 'e.g. High-efficiency panels for maximum energy production' }
    ],
    SolarBattery: [
        { key: 'capacity', label: 'Capacity (kWh)', type: 'number', placeholder: '5' },
        { key: 'description', label: 'Description', type: 'text', placeholder: 'e.g. Store excess energy for use when you need it' }
    ],
    SolarInverter: [
        { key: 'description', label: 'Description', type: 'text', placeholder: 'e.g. Converts DC power from panels to AC for your home' }
    ],
    MonitoringSystem: [
        { key: 'description', label: 'Description', type: 'text', placeholder: 'e.g. Track your energy production in real-time' }
    ],
    PowerDiverter: [
        { key: 'description', label: 'Description', type: 'text', placeholder: 'e.g. Automatically diverts excess energy to your hot water' }
    ],
    EVCharger: [
        { key: 'model', label: 'Model', type: 'text', placeholder: '' },
        { key: 'warranty', label: 'Warranty (Years)', type: 'warranty' },
        { key: 'description', label: 'Description', type: 'text', placeholder: 'e.g. Charge your electric vehicle using solar power' }
    ],
    BlackoutProtection: [
        { key: 'description', label: 'Description', type: 'text', placeholder: 'e.g. Automatic backup power during outages' }
    ],
    SmartDevice: [
        { key: 'description', label: 'Description', type: 'text', placeholder: 'e.g. Smart energy management device' }
    ],
    Optimiser: [
        { key: 'description', label: 'Description', type: 'text', placeholder: 'e.g. Panel-level power optimiser for maximum output' }
    ],
    HeatPump: [
        { key: 'model', label: 'Model', type: 'text', placeholder: '' },
        { key: 'outputKw', label: 'Output (kW)', type: 'number', placeholder: '9' },
        { key: 'source', label: 'Source', type: 'select', options: heatPumpSourceOptions },
        { key: 'warranty', label: 'Warranty (Years)', type: 'warranty' },
        { key: 'description', label: 'Description', type: 'text', placeholder: 'e.g. Air-to-water heat pump for efficient home heating' }
    ],
    WaterCylinder: [
        { key: 'capacity', label: 'Capacity (Litres)', type: 'number', placeholder: '300' },
        { key: 'description', label: 'Description', type: 'text', placeholder: 'e.g. Hot water storage cylinder for your heat pump system' }
    ],
    Insulation: [
        { key: 'warranty', label: 'Warranty (Years)', type: 'warranty', options: warrantyYearOptions0to30 },
        { key: 'description', label: 'Description', type: 'text', placeholder: 'e.g. High-performance insulation to reduce heat loss' }
    ]
};